import { render, staticRenderFns } from "./SystemSelector.vue?vue&type=template&id=19336aa5&scoped=true&"
import script from "./SystemSelector.vue?vue&type=script&lang=js&"
export * from "./SystemSelector.vue?vue&type=script&lang=js&"
import style0 from "./SystemSelector.vue?vue&type=style&index=0&id=19336aa5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19336aa5",
  null
  
)

export default component.exports